import React from 'react';
import styles from './index.module.css';

export default function VonjoThankYouPage({}) {
  return (
    <div className={styles.thank_you_container}>
      <div className={styles.thank_you}>Thank you!</div>
      <div className={styles.whats_next}>What's next?</div>
      <div className={styles.thank_you_text}>
        Thank you for requesting a call with your mentor! We will contact you shortly to schedule a time. During the
        call, you can learn how they cope with their disease, hear about their disease experience, and understand their
        treatment journey.
      </div>
      <div className={styles.thank_you_text}>
        If you would like to contact us directly, please email us at{' '}
        <a className={styles.thank_you_link} href='mailto:info@patientpartner.com'>
          info@patientpartner.com
        </a>{' '}
        or call us at <a href='tel:6192681112'>619-268-1112</a>.
      </div>
    </div>
  );
}
